import React, { useState, useEffect } from "react";
import "./App.css";

function App() {
  const [emails, setEmails] = useState([]);
  const [emailFilter, setEmailFilter] = useState(""); // Estado para el correo a buscar
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const fetchEmails = async () => {
    setLoading(true);
    setError("");
    setEmails([]);

    try {
      const response = await fetch("https://sx.y9x.ovh/melo/api/emails", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ emailFilter }),
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.error || "Error en el servidor");
      }

      const data = await response.json();
      setEmails(data);
    } catch (err) {
      console.error("Error fetching emails:", err);
      setError(err.message || "Error al cargar correos.");
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = (e) => {
    e.preventDefault();
    if (emailFilter.trim()) {
      fetchEmails();
    }
  };

  return (
    <div className="app">
      <header>
        <form onSubmit={handleSearch} className="search-form">
          <div className="search-container">
            <input
              type="email"
              placeholder="Ingrese correo a buscar (ej: usuario@dominio.com)"
              value={emailFilter}
              onChange={(e) => setEmailFilter(e.target.value)}
              disabled={loading}
              required
            />
            <button type="submit" disabled={loading}>
              {loading ? "Buscando..." : "Buscar"}
            </button>
          </div>
          {error && <div className="error">{error}</div>}
        </form>
      </header>

      <div className="emails-container">
        {emails.length > 0
          ? emails.map((email) => (
              <div key={email.id} className="email-card">
                <div className="email-header">
                  <h3>{email.subject}</h3>
                  <div className="email-meta">
                    <p>
                      <strong>De:</strong> {email.from}
                    </p>
                    <p>
                      <strong>Fecha:</strong>{" "}
                      {new Date(email.date).toLocaleString()}
                    </p>
                  </div>
                </div>

                <div className="email-content">
                  {email.contentType === "text/html" ? (
                    <div
                      className="email-html"
                      dangerouslySetInnerHTML={{ __html: email.body }}
                    />
                  ) : (
                    <pre className="email-text">{email.body}</pre>
                  )}
                </div>
              </div>
            ))
          : !loading && <div className="empty">No se encontraron correos</div>}
      </div>
    </div>
  );
}

export default App;
